import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/collapseHighlightsSectionPdp/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showCollapseHighlightsSectionPdpSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showCollapseHighlightsSectionPdpSelector };
